import React, { useState } from 'react';

const OptimizedImage = ({ src, alt, className, style, width, height, ...props }) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(false);

  const getCleanSrc = (inputSrc) => {
    if (!inputSrc || typeof inputSrc !== 'string') return inputSrc;
    let cleanPath = inputSrc;
    
    if (inputSrc.includes("public/")) {
      const index = inputSrc.indexOf("public/");
      cleanPath = inputSrc.substring(index);
    } else if (inputSrc.includes("gamedoc/")) {
      const index = inputSrc.indexOf("gamedoc/");
      cleanPath = "public/" + inputSrc.substring(index);
    }

    // Since this is the Admin app, we need to know the API base URL.
    // If inputSrc already had http, we can extract it, otherwise use fallback.
    if (inputSrc.startsWith("http")) {
      try {
        const urlObj = new URL(inputSrc);
        const formattedPath = cleanPath.startsWith('/') ? cleanPath.substring(1) : cleanPath;
        return `${urlObj.protocol}//${urlObj.host}/${formattedPath}`;
      } catch (e) {
        return inputSrc;
      }
    }
    
    return inputSrc; // Fallback for local assets
  };

  const finalSrc = getCleanSrc(src);

  const containerStyle = {
    position: 'relative',
    overflow: 'hidden',
    width: width || (style && style.width) || '100%',
    height: height || (style && style.height) || '100%',
    ...style,
  };

  return (
    <div className={`shimmer-wrapper ${!isLoaded ? 'skeleton-box' : ''} ${className || ''}`} style={containerStyle}>
      <img
        src={finalSrc}
        alt={alt}
        className={`fade-in ${className || ''}`}
        style={{
          width: '100%',
          height: '100%',
          objectFit: style?.objectFit || 'cover',
          display: isLoaded ? 'block' : 'none',
          ...style,
        }}
        onLoad={() => setIsLoaded(true)}
        onError={() => {
          setIsLoaded(true);
          setError(true);
        }}
        loading="lazy"
        {...props}
      />
      {!isLoaded && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
          }}
        />
      )}
      {error && (
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f0f0f0',
          color: '#999',
          fontSize: '12px'
        }}>
          Error
        </div>
      )}
    </div>
  );
};

export default OptimizedImage;
